// extracted by mini-css-extract-plugin
export default {"row":"InstructionRow_row__3JZU6","connectorLine":"InstructionRow_connectorLine__Y5saT","lineDot":"InstructionRow_lineDot__vQgIw","text":"InstructionRow_text__ZbogB"};